import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ReplaySubject } from 'rxjs/ReplaySubject';
import { Subscription } from 'rxjs/Subscription';
import Swal from 'sweetalert2';
import { AccountsService } from '../../services/accounts.service';
import { SalesActivityService } from '../../services/sales-activity.service';
import { LogService } from '../../services/shared/log.service';
import { NGaugeService } from '../../services/shared/ngauge.service';
import { PubSubService } from '../../services/shared/pub-sub.service';
import { UserService } from '../../services/user.service';
import { ACCOUNT_ADD_EDIT_DATA, ACCOUNT_DATA, ACCOUNT_INFO, ADD_PAGE, DISABLED_ACCOUNT, EDIT_PAGE, LOG_LEVELS, LOG_MESSAGES, PHONE_MASK_PATTERN, SALES_ACTIVTY_TYPE, SINGLE_PROPERTY, TEXT_AREA_TOOL_TIP } from '../../util/constants';
import { DateUtil } from '../../util/dateUtil';

@Component({
  selector: 'app-sales-activity-add-edit',
  templateUrl: './sales-activity-add-edit.component.html',
  styleUrls: ['./sales-activity-add-edit.component.scss']
})
export class SalesActivityAddEditComponent implements OnDestroy, AfterViewInit {

  salesActivityForm: FormGroup;
  salesActivityData: any;
  viewMode = '';
  accounts = [];
  contacts = [];
  assignees = [];
  minEndDate: Date;
  accountId: number;
  salesActivityEditId: number;
  userInfo: any;
  salesData: any;
  completionForm: boolean;
  backupSalesPersons: any;
  currentPagePath: string;
  isLoading = true;
  filteredSalesActivity: ReplaySubject<string[]> = new ReplaySubject<string[]>(1);
  saFilterCtrl: FormControl = new FormControl();
  filteredAssign: ReplaySubject<string[]> = new ReplaySubject<string[]>(1);
  assigneeFilterCtrl: FormControl = new FormControl();
  filteredAccount: ReplaySubject<string[]> = new ReplaySubject<string[]>(1);
  accountFilterCtrl: FormControl = new FormControl();
  filteredContact: ReplaySubject<string[]> = new ReplaySubject<string[]>(1);
  contactFilterCtrl: FormControl = new FormControl();
  filteredProperty: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  propertyFilterCtrl: FormControl = new FormControl();
  phoneMask = PHONE_MASK_PATTERN;
  selectedContact = '';
  resultRequiredIfActivityCompleted = false;
  contactId: any;
  allContacts = [];
  repeatSalesActivityAdd = false;
  formCompleted = false;
  accountStatus = true;
  textToolTip = TEXT_AREA_TOOL_TIP;
  disableAccount = false;
  isClusterproperty = false;

  salesActivitySubscription: Subscription;
  accountSubscription: Subscription;
  getSalesActivityByIdSubscription: Subscription;
  findUserbyIdSubscription: Subscription;
  getAccountsListSubscription: Subscription;
  getadminUserSubscription: Subscription;
  saveSalesActivitySubscription: Subscription;
  groupSalesActivityTypeSubscription: Subscription;
  getSAByIdSubscription: Subscription;
  getContcatsSubscription: Subscription;
  getPropertyListSubscription: Subscription;
  getAccountNameByIdSubscription: Subscription;
  propertiesList: any;
  inValidMobile: boolean;

  constructor(private fb: FormBuilder,
    private userService: UserService,
    private logService: LogService,
    private ngaugeService: NGaugeService,
    private pubSubService: PubSubService,
    private salesService: SalesActivityService,
    private accountService: AccountsService,
    private ref: ChangeDetectorRef) {
    const url = this.ngaugeService.getCurrentUrl();
    if (url.includes('account')) {
      const account = ngaugeService.isJSON(sessionStorage.getItem(ACCOUNT_INFO));
      this.accountId = account['id'];
      this.salesActivityEditId = account['editId'];
      this.accountStatus = account['status'];
    }
    this.isClusterproperty = this.ngaugeService.getIsClusterProperty();
    if (this.isClusterproperty) {
      this.getPropertyListSubscription = this.ngaugeService.getPropertyTypesList().subscribe(types => {
        this.propertiesList = types;
        this.ngaugeService.buildFilter(this.propertyFilterCtrl, this.filteredProperty, types, 'name');
      });
    }
  }

  async ngAfterViewInit() {
    this.getContcatsSubscription = this.salesService.getAllContacts().subscribe(async (contacts: any) => {
      contacts = this.ngaugeService.appendFNameAndLName(contacts);
      this.allContacts = contacts;
      this.getSalesActivities();
      await this.getAdminUsers();
      this.salesActivityForm = this.buildForm();
      this.accountStatus = true;
      await this.getAccounts();
      this.checkForRouting();
      this.completed.valueChanges.subscribe(checked => {
        if (checked) {
          this.resultRequiredIfActivityCompleted = this.result.value === '' ? true : false;
          this.result.setValidators([Validators.required, Validators.maxLength(10000)]);
          this.salesActivityForm.get('completionDate').setValue(new Date());
          if (this.result.value === '') {
            this.result.setErrors({ 'incorrect': true });
          }
        } else {
          this.resultRequiredIfActivityCompleted = checked;
          this.result.clearValidators();
          this.salesActivityForm.get('completionDate').setValue('');
          this.salesActivityForm.get('result').setValue('');
          this.result.setErrors(null)
        }
      });
      this.result.valueChanges.subscribe(resultfilled => {
        if (this.resultRequiredIfActivityCompleted) {
          this.resultRequiredIfActivityCompleted = resultfilled.length > 3 ? false : true;
        }
      });
    }, error => {
      this.logService.logError(LOG_LEVELS.ERROR, 'On Sales Activity Add/Edit Component', 'On Fetch contacts', JSON.stringify(error));
    });
  }

  getSalesActivities() {
    this.groupSalesActivityTypeSubscription = this.salesService.getSalesActivityTypes().
      subscribe((activities: any) => {
        this.ngaugeService.buildFilter(this.saFilterCtrl, this.filteredSalesActivity, activities, 'name');
      }, error => {
        this.logService.logError(LOG_LEVELS.ERROR, 'On Sales Activity Add/Edit Component', 'On Fetch Sales Activity Types',
          JSON.stringify(error));
      });
  }

  async checkForRouting() {
    this.currentPagePath = this.ngaugeService.getCurrentUrl();
    this.viewMode = this.currentPagePath.includes('add') ? ADD_PAGE : EDIT_PAGE;
    this.completionForm = false;
    if (this.salesService.formValues === undefined) {
      if (this.viewMode === EDIT_PAGE && this.currentPagePath.includes('editsalesActivities')) {
        await this.getSalesActivityById({ id: this.salesActivityEditId });
      } else if (this.viewMode === EDIT_PAGE) {
        this.salesActivitySubscription = this.salesService.salesActivity$.subscribe(async salesData => {
          await this.getSalesActivityById(salesData);
        });
      } else {
        this.userInfo = this.userService.getSessionStorage();
        this.salesActivityForm.patchValue({ createdBy: this.userInfo['userName'] });
        this.assigned.setValue(this.userInfo['userName']);
        const currentProperty = this.userService.getLoggedInUserProperty();
        this.salesActivityForm.get('property').setValue(currentProperty);
      }
    } else {
      this.userInfo = this.salesService.userInfo;
      this.salesActivityForm.patchValue({ 'createdBy': this.userInfo['userName'] });
      this.salesActivityForm.patchValue(this.salesService.formValues);
      this.salesActivityData = { id: this.salesService.formValues['id'] ? this.salesService.formValues['id'] : 0 };
      if (this.salesService.formValues['accountId'] !== '') {
        this.populateContacts(this.salesService.formValues['accountId']);
      }
      if (this.salesService.formValues['contact'] !== '') {
        this.populatePhoneNumber(Number(this.salesService.formValues['contact']));
      }
      this.salesService.formValues = undefined;
    }
    if (this.viewMode === ADD_PAGE) {
      const filteredAccount = this.accounts.filter(account => account['id'] === this.accountId);
      if (filteredAccount.length > 0) {
        this.salesActivityForm.patchValue({ 'accountId': filteredAccount[0]['id'] });
        this.populateContacts(filteredAccount[0]['id']);
      }
    }
    this.isLoading = false;
  }

  getSalesActivityById(salesActivity): Promise<void> {
    return new Promise(resolve => {
      this.getSalesActivityByIdSubscription = this.salesService.getSalesActivityById(salesActivity.id).
        subscribe(async (salesActivityData: any) => {
          this.salesActivityData = salesActivityData[0];
          const findAccount = this.accounts.find(account => account.id === this.salesActivityData.accountId);
          if (findAccount === undefined) {
            this.disableAccount = true;
            await this.getAccountName(this.salesActivityData.accountId);
          }
          await this.checkForOldSalesPerson();
          this.populateData(this.salesActivityData, salesActivity);
          resolve();
        }, error => {
          this.logService.logError(LOG_LEVELS.ERROR, 'On Sales Activity Add/Edit Component', 'On Fetch Sales Activity By Id',
            JSON.stringify(error));
        });
    });
  }

  getAccountName(accountId): Promise<void> {
    return new Promise(resolve => {
      this.getAccountNameByIdSubscription = this.accountService.getAccountNameById(accountId).
        subscribe(response => {
          this.accounts.push(response[0]);
          this.ngaugeService.buildFilter(this.accountFilterCtrl, this.filteredAccount, this.accounts, 'account');
          this.ref.detectChanges();
          resolve();
        });
    });
  }

  checkForOldSalesPerson() {
    return new Promise(async resolve => {
      if (this.assignees.length === 0) {
        await this.getAdminUsers();
      }
      const assignedPerson = this.assignees.filter(assignee => assignee.userName === this.salesActivityData.assigned);
      if (assignedPerson.length === 0) {
        const user = this.ngaugeService.getInvalidUser(this.salesActivityData.assigned);
        this.assignees.push(user);
        console.log('Old User Found');
        this.setFilterDataForAssignee();
        resolve(true);
      } else {
        resolve(true);
      }
    });
  }

  buildForm() {
    return this.fb.group({
      createdBy: ['', Validators.required],
      salesActivityType: ['', Validators.required],
      accountId: ['', Validators.required],
      contact: ['', Validators.required],
      startDate: ['', Validators.required],
      startTime: [''],
      endDate: [''],
      endTime: [''],
      type: [''],
      contactDetail: [''],
      allDay: [false],
      repeatEveryDay: [false],
      priority: [false],
      assigned: ['', Validators.required],
      objective: ['', [Validators.required, Validators.maxLength(1000)]],
      completed: [false],
      completionDate: [''],
      result: [''],
      property: ['']
    });
  }

  get assigned() {
    return this.salesActivityForm.get('assigned') as FormControl;
  }

  get phoneNumber() {
    return this.salesActivityForm.get('contactDetail') as FormControl;
  }
  get completed() {
    return this.salesActivityForm.get('completed') as FormControl;
  }

  get result() {
    return this.salesActivityForm.get('result') as FormControl;
  }

  addAccount() {
    const fromUrl = this.viewMode;
    this.salesService.formValues = this.salesActivityForm.value;
    this.salesService.formValues['id'] = this.salesActivityData ? this.salesActivityData['id'] : 0;
    this.salesService.userInfo = this.userInfo;
    if (this.currentPagePath.includes('/salesList')) {
      sessionStorage.setItem(ACCOUNT_ADD_EDIT_DATA,
        JSON.stringify({
          accountId: 0, accountName: '', fromPath: 'SalesActivity', fromUrl: fromUrl, status: this.accountStatus
        }));
    } else if (this.currentPagePath.includes('/sales')) {
      sessionStorage.setItem(ACCOUNT_ADD_EDIT_DATA,
        JSON.stringify({
          accountId: 0, accountName: '', fromPath: 'Sales', fromUrl: fromUrl, previousAccountId: this.accountId,
          salesActivityId: this.salesActivityEditId, status: this.accountStatus
        }));
    } else if (this.currentPagePath.includes('/editsalesActivities')) {
      const salesActivityDetail = this.getSalesDetails(fromUrl);
      salesActivityDetail['salesActivityId'] = this.salesActivityEditId;
      sessionStorage.setItem(ACCOUNT_ADD_EDIT_DATA,
        JSON.stringify(salesActivityDetail));
    } else if (this.currentPagePath.includes('/addsalesActivities')) {
      const salesActivityDetail = this.getSalesDetails(fromUrl);
      salesActivityDetail['salesActivityId'] = 0;
      sessionStorage.setItem(ACCOUNT_ADD_EDIT_DATA,
        JSON.stringify(salesActivityDetail));
    }
    const action = this.viewMode === EDIT_PAGE ? EDIT_PAGE : ADD_PAGE;
    this.logUserActivity(' Sales Activity - ' + action, '“New Account” Click');
    this.ngaugeService.routeTo('/account/add');
  }

  getSalesDetails(fromUrl) {
    return {
      accountId: 0, accountName: '', fromPath: 'accountDetail', fromUrl,
      previousAccountId: this.accountId, salesActivityId: this.salesActivityEditId,
      status: this.accountStatus
    };
  }

  addContact() {
    const fromUrl = this.viewMode;
    this.salesService.formValues = this.salesActivityForm.value;
    this.salesService.formValues['id'] = this.salesActivityData ? this.salesActivityData['id'] : 0;
    this.salesService.userInfo = this.userInfo;
    const filteredAccount = this.accounts.filter(account => account['id'] === this.salesActivityForm.value['accountId']);
    if (this.currentPagePath.includes('/salesList')) {
      sessionStorage.setItem(ACCOUNT_DATA, JSON.stringify({
        accountId: this.accountId, status: this.accountStatus
      }));
      sessionStorage.setItem(ACCOUNT_INFO, JSON.stringify({
        accountName: filteredAccount[0]['account'], fromPath: 'SalesActivity', fromUrl, status: this.accountStatus,
        editId: 0, id: this.salesActivityForm.value['accountId']
      }));
    } else if (this.currentPagePath.includes('/sales')) {
      sessionStorage.setItem(ACCOUNT_DATA, JSON.stringify({
        accountId: this.accountId, status: this.accountStatus
      }));
      sessionStorage.setItem(ACCOUNT_INFO, JSON.stringify({
        accountName: filteredAccount[0]['account'], fromPath: 'Sales', fromUrl, status: this.accountStatus, editId: 0,
        id: this.salesActivityForm.value['accountId']
      }));
    } else if (this.currentPagePath.includes('/editsalesActivities')) {
      sessionStorage.setItem(ACCOUNT_INFO, JSON.stringify({
        accountName: filteredAccount[0]['account'], fromPath: 'accountDetail', fromUrl, previousAccountId: this.accountId,
        salesActivityId: this.salesActivityEditId, status: this.accountStatus, editId: 0, id: this.salesActivityForm.value['accountId']
      }));
    } else if (this.currentPagePath.includes('/addsalesActivities')) {
      sessionStorage.setItem(ACCOUNT_INFO, JSON.stringify({
        accountName: filteredAccount[0]['account'], fromPath: 'accountDetail', fromUrl, previousAccountId: this.accountId,
        salesActivityId: 0, status: this.accountStatus, editId: 0, id: this.salesActivityForm.value['accountId']
      }));
    }
    const action = this.viewMode === EDIT_PAGE ? EDIT_PAGE : ADD_PAGE;
    this.logUserActivity(' Sales Activity - ' + action, '“New Contact” Click');
    this.ngaugeService.routeTo('/account/detail/addContact');
  }

  populateData(salesActivityData, salesData) {
    const userId = salesActivityData['createdBy'];
    if (salesActivityData['completed']) { this.formCompleted = true; }
    this.findUserbyIdSubscription = this.userService.findUserbyId(userId).
      subscribe(user => {
        this.userInfo = user; // used on update while saving sales on createdBy
        const userName = user['userName'];
        const filteredAccount = this.accounts.filter(account => account.id === salesActivityData['accountId']);
        this.accountStatus = filteredAccount.length > 0 ? (filteredAccount[0]['status'] === DISABLED_ACCOUNT ? false : true) : false;
        if (this.salesActivityData['completionDate'] !== '' && this.salesActivityData['completionDate'] !== null) {
          this.salesActivityData['completionDate'] = DateUtil.getValidTimeZone(this.salesActivityData['completionDate']);
        }
        this.salesActivityForm.patchValue(this.salesActivityData);
        this.salesActivityForm.patchValue({
          createdBy: userName,
          contactDetail: this.salesActivityForm['value']['contactDetail']
        });
        this.salesActivityForm.get('startDate').setValue(DateUtil.getNewDate(salesActivityData['startDate']));
        this.salesActivityForm.get('endDate').setValue(DateUtil.getNewDate(salesActivityData['endDate']));
        if (this.completionForm === true) {
          if (this.salesActivityForm.controls['completionDate'].value === '' || this.salesActivityData['completionDate'] === null) {
            this.salesActivityForm.get('completionDate').setValue(new Date());
          } else {
            this.salesActivityForm.patchValue({
              completionDate: DateUtil.getValidTimeZone(this.salesActivityForm['value']['completionDate'])
            });
          }
        }
        if (salesData['completion']) {
          this.completionForm = true;
          this.salesActivityForm.get('completed').setValue(true);
          this.salesActivityForm.get('completionDate').setValue(new Date());
        }
        this.populateContacts(salesActivityData['accountId']);
        this.populatePhoneNumber(Number(salesActivityData['contact']));
        this.isLoading = false;
      }, error => {
        this.logService.logError(LOG_LEVELS.ERROR, 'On Sales Activity Add/Edit Component', 'On Fetch User By Id', JSON.stringify(error));
      });
    this.setEndDateLimit(this.salesActivityData['startDate']); // setting limit for End Date
  }

  setEndDateLimit(startDate) {
    if (startDate !== null) {
      this.minEndDate = DateUtil.getNewDate(startDate);
    } else {
      this.minEndDate = this.viewMode === EDIT_PAGE ? this.salesActivityData['startDate'] : new Date();
    }
    if (startDate === null) {
      this.resetDate('startDate');
    }
    this.salesActivityForm.controls['startTime'].patchValue('');
    this.salesActivityForm.controls['endDate'].patchValue('');
    this.salesActivityForm.controls['endTime'].patchValue('');
  }

  getAccounts(): Promise<void> {
    return new Promise(resolve => {
      this.accounts = [];
      const isClusterproperty = this.ngaugeService.getIsClusterProperty();
      const userProperty = this.userService.getLoggedInUserProperty();
      this.getAccountsListSubscription = this.salesService.getAccountsList(isClusterproperty, userProperty).
        subscribe((accounts: any) => {
          this.accounts = accounts;
          this.ngaugeService.buildFilter(this.accountFilterCtrl, this.filteredAccount, this.accounts, 'account');
          resolve();
        }, error => {
          this.logService.logError(LOG_LEVELS.ERROR, 'On Sales Activity Add/Edit Component', 'On Fetch Accounts', JSON.stringify(error));
        });
    });
  }

  getAdminUsers() {
    return new Promise(resolve => {
      this.getadminUserSubscription = this.userService.getActiveusers().
        subscribe((response: any) => {
          this.backupSalesPersons = this.assignees = response;
          this.setFilterDataForAssignee();
          // this.salesPersonDatasource = new MatTableDataSource<any>(this.assignees);
          resolve(true);
        }, error => {
          resolve(true);
          this.logService.logError(LOG_LEVELS.ERROR, 'On Sales Activity Add/Edit Component', 'On Fetch Users', JSON.stringify(error));
        });
    });
  }

  setFilterDataForAssignee() {
    this.ngaugeService.buildFilter(this.assigneeFilterCtrl, this.filteredAssign, this.assignees, 'userName');
  }

  blockAlpha(event) {
    this.ngaugeService._keyPress(event);
  }

  resetDate(date) {
    const patchValue = this.salesActivityData !== undefined ?
      this.salesActivityData[date] :
      new Date();
    this.salesActivityForm.controls[date].patchValue(patchValue);
    this.ngaugeService.toastrError('Invalid Date Found');
  }

  clearEndTime() {
    this.salesActivityForm.controls['endTime'].patchValue('');
  }

  completeClicked() {
    const completeValue = this.salesActivityForm.get('completed').value;
    if (!completeValue) {
      this.salesActivityForm.get('completionDate').setValue(new Date());
    } else {
      this.salesActivityForm.get('completionDate').setValue('');
    }
  }

  resetEndTime(date) {
    if (date === null) {
      this.ngaugeService.toastrError('Invalid date found');
      this.salesActivityForm.controls['endDate'].patchValue('');
    } else {
      this.salesActivityForm.controls['endTime'].setValue('');
    }
  }

  endTimeShow(toTime) {
    const fromDate = this.salesActivityForm.controls['startDate'].value;
    const toDate = this.salesActivityForm.controls['endDate'].value;
    const dateDiff = this.getDiffBetwnTwoDays(fromDate, toDate);
    if (dateDiff === 0) { // reset date when on same date choosen
      const fromTime = this.salesActivityForm.controls['startTime'].value;
      if (fromTime !== '' && toTime !== '') {
        if (fromTime > toTime) {
          this.ngaugeService.toastrWarning('Invalid Time Found');
          this.salesActivityForm.controls['endTime'].setValue('');
        }
        if (fromTime === toTime) {
          this.ngaugeService.toastrWarning('Start time and end time should not be same');
          this.salesActivityForm.controls['endTime'].setValue('');
        }
      }
    }
  }

  separateHourMinuteHands(hoursMinute) {
    return hoursMinute.split(':');
  }

  getDiffBetwnTwoDays(fromDate, toDate) {
    return Math.round((toDate - fromDate) / (1000 * 60 * 60 * 24));
  }

  repeatEveryDay(value) {
    if (value.checked) {
      const fromDate = this.salesActivityForm.controls['startDate'].value;
      const toDate = this.salesActivityForm.controls['endDate'].value;
      const dateDiff = this.getDiffBetwnTwoDays(fromDate, toDate);
      if (dateDiff > 0) {
        this.salesActivityForm.get('endDate').setValue(fromDate);
        this.salesActivityForm.get('endTime').setValue('');
        this.ngaugeService.toastrWarning('Repeat everyday start and end date should be same');
      }
    }
  }

  pasteClipboardContent(formGroup, formField, field) {
    const action = this.viewMode === EDIT_PAGE ? EDIT_PAGE : ADD_PAGE;
    this.logUserActivity('Sales Activity - ' + action, field);
    let preValue = this[formGroup].get(formField).value;
    preValue = preValue === null ? '' : preValue;
    this.ngaugeService.getClipboardContent().then(text => {
      this[formGroup].get(formField).patchValue(preValue + text);
    });
  }

  async saveSalesActivity(formValues) {
    if (this.salesActivityForm.value.completed) {
      this.salesActivityForm.markAsDirty();
    }
    formValues['salesPerson'] = this.assignees.filter(assignee => assignee['userName'] === formValues['assigned'])[0]['id'];
    if (formValues['salesPerson'] === 0) {
      this.assigned.setValue('');
      document.getElementById('assigned').focus();
      this.ngaugeService.toastrError('In-Active Assignee found');
      return;
    }
    if (this.salesActivityForm.dirty) {
      if (formValues.completed) {
        const result = formValues.result.trim();
        if (result.length === 0) {
          // Show Error Message //
          this.resultRequiredIfActivityCompleted = true;
          return;
        }
      }
      formValues['objective'] = formValues['objective'].trim();
      if (formValues['startTime'] !== '' && formValues['endTime'] === '') {
        this.ngaugeService.toastrError('Please fill time for Sales Activity');
      } else {
        formValues = this.validateTime(formValues);
        if (this.accountId !== undefined) {
          formValues['accountId'] = this.accountId;
        }
        formValues['type'] = SALES_ACTIVTY_TYPE;
        formValues['createdBy'] = this.userInfo['id'];
        formValues['contact'] = this.contactId;
        formValues['id'] = this.salesActivityData ? this.salesActivityData['id'] : 0;
        if (formValues['completionDate'] !== '' && formValues['completionDate'] !== null) {
          formValues['completionDate'] = DateUtil.getDateInMMDDYYYYNew(formValues['completionDate']);
        }
        if (this.viewMode === EDIT_PAGE) {
          formValues = this.validateDatesForTimeZone(formValues);
          const swalObject = {
            title: '<strong>Are you sure</strong>',
            text: 'Do you want to Update Sales Activity',
            confirmButtonText: 'Yes, Update it!',
            cancelButtonText: 'No'
          };
          const areYouSure = this.ngaugeService.swalOkCancelButton(swalObject);
          Swal(areYouSure).then(result => {
            if (result.value) {
              this.save(formValues);
            }
          });
        } else {
          const swalObject = {
            title: '<strong>Are you sure</strong>',
            text: 'Do you want to Add Account Sales Activity',
            confirmButtonText: 'Yes, Add it!',
            cancelButtonText: 'No'
          };
          formValues['startDate'] = DateUtil.setHoursToZero(DateUtil.getNewDate(formValues['startDate']));
          formValues['endDate'] = DateUtil.setHoursToZero(DateUtil.getNewDate(formValues['endDate']));
          const areYouSure = this.ngaugeService.swalOkCancelButton(swalObject);
          Swal(areYouSure).then(result => {
            if (result.value) {
              this.save(formValues);
            }
          });
        }
      }
    } else {
      if (!this.repeatSalesActivityAdd) {
        this.pubSubService.publish('sales-modified-event');
        this.pubSubService.publish('appointment-modified-event');
        this.closeAddEditSalesActivity();
      } else {
        await this.checkForRepeatSalesActivity();
      }
    }
  }

  save(formValues) {
    if (formValues['completionDate'] === '') {
      formValues['completionDate'] = null;
    }
    const filterSalesPerson = this.backupSalesPersons.filter(person => person['userName'] === formValues['assigned']);
    if (filterSalesPerson.length > 0) {
      formValues['userType'] = filterSalesPerson[0]['jobTitle'];
    }
    if (formValues['completed']) {
      const action = this.viewMode === EDIT_PAGE ? EDIT_PAGE : ADD_PAGE;
      const url = this.ngaugeService.getCurrentUrl();
      const screen = url.includes('/salesList') ? 'Sales Activities' : url.includes('/sales') ?
        'Sales Agenda' : 'Account - Sales Activites';
      const completedDate = this.ngaugeService.checkForValidity(formValues['completionDate']) ?
        new Date(formValues['completionDate']) : new Date();
      if (formValues['endDate'] < completedDate) {
        this.logFieldOnUpdate(screen + ' - ' + action, 'End Date', formValues['endDate'], completedDate);
        formValues['endDate'] = completedDate;
      } else if (formValues['endDate'] > completedDate) {
        if (formValues['startDate'] > completedDate) {
          this.logFieldOnUpdate(screen + ' - ' + action, 'Start Date', formValues['startDate'], completedDate);
          formValues['startDate'] = completedDate;
        }
        this.logFieldOnUpdate(screen + ' - ' + action, 'End Date', formValues['endDate'], completedDate);
        formValues['endDate'] = completedDate;
      }
    }
    this.saveSalesActivitySubscription = this.salesService.saveSalesActivity(formValues).
      subscribe(async (response: any) => {
        if (response['result']) {
          const filterAccount = this.accounts.filter(account => account.id === formValues['accountId']);
          const action2 = this.viewMode === EDIT_PAGE ? EDIT_PAGE : ADD_PAGE;
          if (filterAccount.length > 0) {
            this.logUserActivity('Sales Activity - ' + action2, filterAccount[0]['account']);
          }
          this.logUserActivity('Sales Activity - ' + action2, formValues['salesActivityType']);
          this.logUserActivity('Sales Activity - ' + action2, LOG_MESSAGES.SAVE);
          const action = this.viewMode === 'Edit' ? 'updated' : 'added';
          this.ngaugeService.toastrSuccess('Sales Activity ' + action + ' successfully');
          await this.checkForRepeatSalesActivity();
        } else {
          const action = this.viewMode === 'Edit' ? 'update' : 'create';
          this.ngaugeService.toastrError('Sales Activity ' + action + ' failed');
          this.logService.logError(LOG_LEVELS.DEBUG, 'On Sales Activity Add/Edit Component', 'On Fetch Sales Activity',
            JSON.stringify(formValues));
        }
      }, error => {
        this.logService.logError(LOG_LEVELS.ERROR, 'On Sales Activity Add/Edit Component', 'On Add Sales Activity', JSON.stringify(error));
      });
  }

  logFieldOnUpdate(screen, field, oldVal, newVal) {
    this.logService.logFieldHistorySystemUpdate(LOG_LEVELS.INFO, this.userService.getLoggedInUserName() + ' - System Update',
      'Sales Activities', screen + ' Sales Activity', field, DateUtil.getDateInMMDDYYYYNew(oldVal), DateUtil.getDateInMMDDYYYYNew(newVal));
  }

  checkForRepeatSalesActivity() {
    return new Promise(resolve => {
      if (!this.repeatSalesActivityAdd) {
        this.pubSubService.publish('sales-modified-event');
        this.pubSubService.publish('appointment-modified-event');
        this.closeAddEditSalesActivity();
      } else {
        delete this.salesActivityForm.value.id;
        this.pubSubService.publish('sales-modified-event');
        this.pubSubService.publish('appointment-modified-event');
        this.salesActivityForm.patchValue({
          startDate: '',
          startTime: '',
          endDate: '',
          endTime: '',
          objective: '',
          completed: false,
          completionDate: '',
          result: '',
          allDay: false,
          repeatEveryDay: false,
          priority: false,
        });
        this.repeatSalesActivityAdd = false;
        this.resultRequiredIfActivityCompleted = false;
        this.viewMode = 'Add';
        this.formCompleted = false;
        this.salesActivityData = undefined;
        this.completionForm = false;
      }
      resolve(true);
    });
  }

  validateTime(formValues) {
    if (formValues['startTime'] === '' && formValues['endTime'] === '') {
      formValues['allDay'] = true;
      formValues['startTime'] = '00:00';
      formValues['endTime'] = '23:59';
      formValues['endDate'] = formValues['startDate'];
      return formValues;
    }
    return formValues;
  }

  validateDatesForTimeZone(formValues) {
    const formController = this.salesActivityForm.controls;
    if (formController['startDate'].pristine) {
      formValues['startDate'] = DateUtil.setHoursToZero(formValues['startDate']);
    }
    if (formController['endDate'].pristine) {
      formValues['endDate'] = DateUtil.setHoursToZero(formValues['endDate']);
    }
    return formValues;
  }

  closeAddEditSalesActivity() {
    const currentPageUrl = this.ngaugeService.getCurrentUrl();
    const action = this.viewMode === EDIT_PAGE ? EDIT_PAGE : ADD_PAGE;
    let routeUrl;
    if (currentPageUrl.includes('/salesList')) {
      routeUrl = '/salesList';
      this.ngaugeService.routeTo(routeUrl);
      this.logService.logUserActivity(LOG_LEVELS.INFO, 'Sales Activities - ' + action + ' Sales Activity', LOG_MESSAGES.CANCEL);
    } else if (currentPageUrl.includes('/sales')) {
      routeUrl = '/sales';
      this.ngaugeService.routeTo(routeUrl);
      this.logService.logUserActivity(LOG_LEVELS.INFO, 'Sales Agenda - ' + action + ' Sales Activity', LOG_MESSAGES.CANCEL);
    } else if (currentPageUrl.includes('account')) {
      this.ngaugeService.routeTo('/account/detail');
      this.logService.logUserActivity(LOG_LEVELS.INFO, 'Sales Activities - View - ' + action + ' Sales Activity', LOG_MESSAGES.CANCEL);
    }
  }

  populateContacts(accountId) {
    this.phoneNumber.reset();
    this.accountId = accountId;
    this.contacts = this.allContacts.filter(contact => contact['accountId'] === accountId);
    if (this.contacts.length === 1) {
      this.salesActivityForm.get('contact').setValue(this.contacts[0]['id']);
      this.contactId=JSON.parse(this.contacts[0]['id'])
      this.populatePhoneNumber(this.contacts[0]['id']);
    }
    this.ngaugeService.buildFilter(this.contactFilterCtrl, this.filteredContact, this.contacts, 'userName');
    if (this.ngaugeService.getIsClusterProperty()) {
      const filteredAccount = this.accounts.filter(account => account.id === accountId);
      if (filteredAccount.length > 0) {
        if (filteredAccount[0]['type'] === SINGLE_PROPERTY) {
          const currentProperty = this.userService.getLoggedInUserProperty();
          this.salesActivityForm.get('property').setValue(currentProperty);
          this.ngaugeService.buildFilter(this.propertyFilterCtrl, this.filteredProperty, [{ name: currentProperty }], 'name');
        } else {
          this.ngaugeService.buildFilter(this.propertyFilterCtrl, this.filteredProperty, this.propertiesList, 'name');
        }
      }
    }
  }

  async populatePhoneNumber(contactId) {
    if (contactId > 0) {
      const filteredContactId = this.allContacts.filter(contact => contact['id'] === contactId)[0];
      const filteredContact =
        await this.userService.populateContactDetails(filteredContactId.userName, this.contacts);
      this.contactId = filteredContact['id'];
      this.salesActivityForm.get('contact').setValue(contactId);
      this.salesActivityForm.get('contactDetail').setValue(filteredContact['preferredContact']);
      this.checkNumber(filteredContact['preferredContact']);
    } else {
      this.salesActivityForm.get('contact').setValue('');
      this.salesActivityForm.get('contactDetail').setValue('');
    }
  }

  checkNumber(mNumber) {
    this.inValidMobile = this.ngaugeService.checkForMobile(mNumber);
  }

  nextSalesActivity(formValues) {
    const action = this.viewMode === EDIT_PAGE ? EDIT_PAGE : ADD_PAGE;
    this.logUserActivity('Sales Activity - ' + action, 'Save and Create New');
    this.repeatSalesActivityAdd = true;
    this.saveSalesActivity(formValues);
  }

  logUserActivity(from, value) {
    this.logService.logUserActivity(LOG_LEVELS.INFO, from, value);
  }

  ngOnDestroy() {
    this.unSubscribe(this.salesActivitySubscription);
    this.unSubscribe(this.accountSubscription);
    this.unSubscribe(this.groupSalesActivityTypeSubscription);
    this.unSubscribe(this.getSalesActivityByIdSubscription);
    this.unSubscribe(this.findUserbyIdSubscription);
    this.unSubscribe(this.getAccountsListSubscription);
    this.unSubscribe(this.getadminUserSubscription);
    this.unSubscribe(this.saveSalesActivitySubscription);
    this.unSubscribe(this.getSAByIdSubscription);
    this.unSubscribe(this.getContcatsSubscription);
    this.unSubscribe(this.getPropertyListSubscription);
    this.unSubscribe(this.getAccountNameByIdSubscription);
    this.salesActivityData = null;
    this.salesActivityForm = null;
    this.viewMode = null;
    this.accounts = null;
    this.contacts = null;
    this.assignees = null;
    this.minEndDate = null;
    this.accountId = null;
    this.salesActivityEditId = null;
    this.userInfo = null;
    this.salesData = null;
    this.completionForm = null;
    this.backupSalesPersons = null;
    this.currentPagePath = null;
    this.isLoading = null;
    this.filteredSalesActivity = null;
    this.saFilterCtrl = null;
    this.filteredAssign = null;
    this.assigneeFilterCtrl = null;
    this.filteredAccount = null;
    this.accountFilterCtrl = null;
    this.filteredContact = null;
    this.contactFilterCtrl = null;
    this.filteredProperty = null;
    this.propertyFilterCtrl = null;
    this.phoneMask = null;
    this.selectedContact = null;
    this.resultRequiredIfActivityCompleted = null;
    this.contactId = null;
    this.allContacts = null;
    this.repeatSalesActivityAdd = null;
    this.formCompleted = null;
    this.accountStatus = null;
    this.textToolTip = null;
    this.disableAccount = null;
    this.isClusterproperty = null;
    this.propertiesList = null;
    this.inValidMobile = null;

    this.fb = null;
    this.userService = null;
    this.logService = null;
    this.ngaugeService = null;
    // this.pubSubService = null;
    this.salesService = null;
    this.accountService = null;
    // this.salesPersonDatasource = null;
    this.ref = null;
  }

  unSubscribe(subscription: any) {
    if (this.ngaugeService.checkForNllUndef(subscription)) {
      subscription.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/sales-activity/sales-activity-add-edit/sales-activity-add-edit.component.ts